import Controller from "csi/action/Controller";
import ViewRef from "csi/def/ViewRef";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";

const AddReferenceToStylesController = declare(Controller, {
	/**
     * Select view to display (Either Shape or Theme Styles)
     *
     * @return {ActionView}
     */
	getActionView(vr) {
		const doc = this.getNode();
		const docOwnerType = this.getContext().cache.getNode(this.getParent()?.__Parent__, true)?.$Type;
		if (docOwnerType === "Shape" || docOwnerType === "Theme") {
			return this.inherited(arguments, [lang.mixin(new ViewRef(), {
				m_id: docOwnerType + "DocumentShareableStyles",
				m_url: doc.$URL,
			})]);
		}

		return null;
	},
});

export = AddReferenceToStylesController;